// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__GdGym","bigColWidth":"Table_bigColWidth__1hb01","biggerColWidth":"Table_biggerColWidth__1SrQC","row":"Table_row__3jiZD","col":"Table_col__3Oa2H"};